
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import { getCleanedJobTitle } from '@twago/configs'

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

export default {
  props: {
    modalOpen: Boolean,
    talentId: {
      type: Number,
      default: 0
    },
    projectData: {
      type: Object,
      required: true
    }
  },
  computed: {
    dialog: {
      get() {
        return this.modalOpen
      },
      set(value) {
        this.$emit('update:modal-open', value)
      }
    },
    referralLink() {
      if (this.talentId) {
        const urlReadyTitle = getCleanedJobTitle(this.projectData.title)
        const urlReadyId = getCleanedJobTitle(`talent_${this.talentId}`)

        return `https://${this.$store.state.clientContext.talentDomainName}/projects/${urlReadyTitle}/${this.projectData.id}?utm_source=${urlReadyId}`
      } else {
        return ''
      }
    }
  },
  methods: {
    fireSuccessToast() {
      this.$toast.fire(this.$t('talent.project.referral.modal.success'), {
        type: 'success'
      })
    },
    fireErrorToast() {
      this.$toast.fire(this.$t('talent.project.referral.modal.error'), {
        type: 'error'
      })
    }
  }
}
